var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseTransition",
    {
      attrs: {
        enabled: _vm.$ui.desktop,
        "leave-duration": 200,
        "enter-duration": 300,
        "enter-active-class": "delay-100",
        animation: "fade"
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.$ui.mobile || !_vm.$search.open,
              expression: "$ui.mobile || !$search.open"
            }
          ],
          staticClass: "inset-y-0 z-50",
          class: {
            "fixed w-screen pr-10 transition-all duration-300": _vm.$ui.mobile,
            "absolute right-0": _vm.$ui.desktop,
            "right-full": _vm.$ui.mobile && !_vm.$ui.menuOpen,
            "right-0": _vm.$ui.mobile && _vm.$ui.menuOpen
          }
        },
        [
          _c(
            "div",
            {
              ref: "mobile-menu",
              staticClass:
                "\n                h-full p-6 flex flex-col bg-white shadow\n                desktop:p-0 desktop:flex-row desktop:items-center desktop:bg-transparent desktop:shadow-none\n            "
            },
            [
              _vm.$ui.mobile && !_vm.$auth.isOffline
                ? _c(
                    "div",
                    { staticClass: "flex items-center" },
                    [
                      _vm.user.avatarUrl
                        ? _c("UserAvatar", {
                            staticClass:
                              "w-16 h-16 mr-4 flex-shrink-0 rounded-full text-primary-900 outline-none shadow-solid"
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "flex flex-col overflow-hidden" },
                        [
                          _c(
                            "span",
                            { staticClass: "truncate text-lg font-bold" },
                            [_vm._v(" " + _vm._s(_vm.user.name) + " ")]
                          ),
                          _vm.userWebId
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "truncate text-sm text-gray-700 hover:underline",
                                  attrs: {
                                    href: _vm.userWebId,
                                    target: "blank"
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.userWebId) + " ")]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "nav",
                {
                  staticClass: "desktop:mt-0",
                  class: { "mt-4": _vm.$ui.mobile && !_vm.$auth.isOffline }
                },
                [
                  _c(
                    "BaseLink",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.$media.empty,
                          expression: "!$media.empty"
                        },
                        { name: "close-menu", rawName: "v-close-menu" }
                      ],
                      ref: "my-collection",
                      staticClass:
                        "\n                        flex items-center h-8 font-semibold text-lg mb-2\n                        desktop:text-sm desktop:mr-4 desktop:mb-0\n                    ",
                      class: { underline: _vm.$route.name === "collection" },
                      attrs: {
                        route: "collection",
                        title:
                          _vm.$route.name !== "collection"
                            ? 'Press "c" to open your collection'
                            : null
                      }
                    },
                    [_vm._v(" My Collection ")]
                  )
                ],
                1
              ),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.$ui.desktop,
                      expression: "$ui.desktop"
                    }
                  ],
                  ref: "button",
                  class: {
                    "rounded-full text-primary-900 focus:outline-none focus:shadow-solid":
                      _vm.user.avatarUrl,
                    "flex w-8 h-8 text-gray-700 items-center justify-center hover:text-gray-800": !_vm
                      .user.avatarUrl
                  },
                  style: _vm.user.avatarUrl
                    ? ""
                    : "margin-left:-.375rem;margin-right:-.375rem",
                  attrs: {
                    type: "button",
                    "aria-label": "Application options"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$ui.toggleMenu()
                    }
                  }
                },
                [
                  _vm.user.avatarUrl
                    ? _c("UserAvatar", {
                        staticClass: "w-12 h-12 rounded-full"
                      })
                    : _c("BaseIcon", {
                        staticClass: "w-5 h-5",
                        attrs: { name: "cog" }
                      })
                ],
                1
              ),
              _c(
                "BaseTransition",
                {
                  attrs: {
                    enabled: _vm.$ui.desktop,
                    duration: 100,
                    animations: "fade scale"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$ui.menuOpen || _vm.$ui.mobile,
                          expression: "$ui.menuOpen || $ui.mobile"
                        }
                      ],
                      ref: "desktop-menu",
                      staticClass:
                        "\n                        w-56 right-0 top-full mt-2 origin-top-right\n                        rounded-md\n                        desktop:absolute desktop:shadow-lg\n                    ",
                      class: {
                        "pb-1 rounded-lg bg-white border border-gray-300 overflow-hidden":
                          _vm.$ui.desktop,
                        "-mt-4": _vm.$ui.desktop && !_vm.user.avatarUrl
                      }
                    },
                    [
                      _vm.$ui.desktop && !_vm.$auth.isOffline
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-col p-4 overflow-hidden bg-gray-200 border-b border-gray-300"
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "truncate font-bold mb-1" },
                                [_vm._v(" " + _vm._s(_vm.user.name) + " ")]
                              ),
                              _vm.userWebId
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "truncate text-sm text-gray-700 hover:underline",
                                      attrs: {
                                        href: _vm.userWebId,
                                        target: "blank"
                                      }
                                    },
                                    [_vm._v(" " + _vm._s(_vm.userWebId) + " ")]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "-mt-4 desktop:mt-0" },
                        _vm._l(_vm.menuOptions, function(menuOption) {
                          return _c(
                            "button",
                            {
                              directives: [
                                { name: "close-menu", rawName: "v-close-menu" }
                              ],
                              key: menuOption.name,
                              staticClass: "flex items-center text-gray-700",
                              class: {
                                "text-lg mt-4 focus:underline hover:underline":
                                  _vm.$ui.mobile,
                                "px-4 py-2 w-full text-sm hover:bg-gray-100 hover:text-gray-900":
                                  _vm.$ui.desktop
                              },
                              attrs: { type: "button" },
                              on: { click: menuOption.handler }
                            },
                            [
                              _c("BaseIcon", {
                                staticClass: "mr-2",
                                class: {
                                  "w-3 h-3": _vm.$ui.desktop,
                                  "w-5 h-5": _vm.$ui.mobile
                                },
                                attrs: { name: menuOption.icon }
                              }),
                              _c("span", { staticClass: "truncate" }, [
                                _vm._v(_vm._s(menuOption.name))
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ]
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }